/**
 * A run's status as a word on a tinted pill, and the "Test" mark (D11b).
 *
 * SHARED BY THE LIST AND THE DETAIL so one status can never be two pills. The
 * WORD carries the meaning and the tone only reinforces it: a reader who cannot
 * tell amber from red still reads "Unklar" and "Fehlgeschlagen".
 */
import React from "react";

import {
  automationRunStatusLabel,
  automationRunStatusTone,
  automationToneClass,
} from "./automationLabels";

/**
 * `badge` ({ label, tone }) is the run's presentation (PC6,
 * `automationRunPresentation`): a payment's ledger outcome, a baseline, an
 * organisation's stop. Without it the pill is the bare status, as before.
 */
export function AutomationRunStatusBadge({ status, badge = null }) {
  const label = badge?.label || automationRunStatusLabel(status);
  const tone = badge?.tone || automationRunStatusTone(status);
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11.5px] font-semibold ${automationToneClass(
        tone
      )}`}
    >
      {label}
    </span>
  );
}

export function AutomationRunTestBadge() {
  return (
    <span className="inline-flex items-center rounded-md border border-border bg-muted px-1.5 py-0.5 text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground">
      Test
    </span>
  );
}
